module.exports = __webpack_public_path__ + "static/img/Zach_Merrett_desktop.76a6285.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zach_Merrett_desktop.jpg
// module id = lHLU
// module chunks = 0